<template>
  <div>
    <div v-if="loading" class="all-center">
      <Loading />
    </div>

    <div class="main">
      <section v-if="!loading" class="content pt-7">
        <div class="public-header">
          <div @click="goHome" class="public-logo">
            <v-img
              class="pointer"
              width="150"
              src="../assets/logo-white.svg"
            ></v-img>
          </div>
        </div>

        <div class="solution">
          <div v-if="found">
            <div :class="[isMobile ? 'px-0 pt-4' : 'pa-4']">
              <PaasSolution
                :title="info.centro"
                :subtitle="info.description"
                titleVariant="highlight"
                :plan="solution"
                :initRoom="roomParam"
                searchEmptyRoom
              />
              <!-- <PaasSolution
                :title="info.description"
                :plan="solution"
                :initRoom="roomParam"
              /> -->
              <p class="mt-6 all-center text-caption">
                Última atualização: {{ info.date }}
              </p>
            </div>
          </div>
          <div class="all-center pa-4" v-if="notPublished">
            <NotFound
              :title="info.centro"
              btn="Ir para home"
              :btnFunction="goHome"
              :text="
                `A alocação de aulas não está disponível. ${info.description}`
              "
            />
            <p class="mt-6">Última atualização: {{ info.date }}</p>
          </div>
          <div class="all-center pa-4" v-if="notFound">
            <NotFound
              title="Ops, não encontramos este centro"
              :text="
                `A alocação de aulas não está disponível para este centro.`
              "
            />
            <p>
              Veja a lista de centros disponíveis:
              <a href="#test">Clique aqui!</a>
            </p>
          </div>

          <PublicFooter
            class="pb-6"
            :period="latestPublishedPeriod"
            :year="footerYear"
          />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading.vue";
import PaasSolution from "@/components/paas/PaasSolution.vue";
import NotFound from "@/components/NotFound.vue";
import PublicFooter from "@/components/PublicFooter.vue";

import { getCenterInfo } from "@/api/paas/center";
import { getPaasPublicDemo } from "@/fixtures/paasPublicDemo";

export default {
  name: "PaasPublica",
  metaInfo: {
    title: "SACI",
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content: `Alocação de aulas a salas. Pesquise por salas ou turmas!`
      }
    ]
  },
  components: {
    Loading,
    PaasSolution,
    NotFound,
    PublicFooter
  },
  data() {
    return {
      solution: [],
      id: "",
      info: {
        centro: "",
        date: "",
        description: ""
      },
      loading: true,
      found: false,
      notFound: false,
      notPublished: false,
      roomParam: -1
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.width < 570;
    },
    latestPublishedPeriod() {
      const periods = [];
      const rooms = this.solution?.solution || [];

      rooms.forEach(room => {
        (room.classes || []).forEach(classItem => {
          const period = this.normalizePeriod(
            classItem.periodo ||
              classItem.period ||
              classItem.semestre ||
              classItem.anoPeriodo
          );
          if (period) periods.push(period);
        });
      });

      return periods.sort((a, b) => {
        return this.periodScore(b) - this.periodScore(a);
      })[0];
    },
    footerYear() {
      const dateYear = String(this.info.date || "").match(
        /\b(19|20)\d{2}\b/
      );
      return dateYear ? dateYear[0] : new Date().getFullYear();
    }
  },
  created() {
    this.$store.commit("setCurrentComponent", {
      component: "Public"
    });
  },

  methods: {
    applyCenterInfo(res) {
      this.solution = res.solution;
      this.info.centro = res.centro;
      this.info.description = res.description;
      this.info.date = res.date;
      this.loading = false;
      this.found = true;
    },
    //finds room index passed trough param
    findRoomIndex(room) {
      //create a array of room names, ex: {bloco: 'CI', sala: '101'} -> 'ci-101'
      let roomList = this.solution.solution.map(el =>
        `${el.bloco}-${el.nome}`
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/[\W_]+/g, "-")
          .toLowerCase()
          .replace(/^-+|-+$/g, "")
      );
      //set index found
      this.roomParam = roomList.findIndex(
        e => e == room.toLocaleLowerCase()
      );
    },
    goHome() {
      this.$router.replace({ name: "Home" });
    },
    normalizePeriod(value) {
      if (!value) return "";

      const periodText = String(value).trim();
      const yearSemester = periodText.match(
        /\b((?:19|20)\d{2})\D*([12])\b/
      );

      if (!yearSemester) return "";
      return `${yearSemester[1]}.${yearSemester[2]}`;
    },
    periodScore(period) {
      const parts = String(period).split(".");
      return Number(parts[0]) * 10 + Number(parts[1]);
    }
  },

  async mounted() {
    let center = this.$route.params.centro;
    this.id = center;
    let room = this.$route.query.sala;

    if (
      String(center).toLowerCase() == "demo" ||
      this.$route.query.demo == "1"
    ) {
      this.applyCenterInfo(getPaasPublicDemo());
      if (room) this.findRoomIndex(room);
      return;
    }

    //get solution on database
    let res = await getCenterInfo(center);

    switch (res.status) {
      //if is published
      case "published":
        this.applyCenterInfo(res);
        //id room param, find index
        if (room) this.findRoomIndex(room);
        break;
      //if academic center exists, but there is no solution
      case "not-published":
        this.info.centro = res.centro;
        this.info.description = res.description;
        this.info.date = res.date;

        this.loading = false;
        this.notPublished = true;
        break;
      //if academic center is not found
      default:
        this.loading = false;
        this.notFound = true;
        break;
    }
  }
};
</script>

<style scoped>
.main {
  /* background: url('../assets/saci-pattern-opacity.png'), linear-gradient(50deg, rgba(71,118,230,1) 0%, rgba(142,84,233,1) 100%);; */
  /* background: url('../assets/saci-pattern-opacity.png'), linear-gradient(135deg, #1491ff, #0346b6); */
  /* background: rgb(71,118,230); */
  /* background: linear-gradient(50deg, rgba(71,118,230,1) 0%, rgba(142,84,233,1) 100%); */
  background: linear-gradient(135deg, #1491ff, #0346b6);
  min-height: 100vh;
}

.content {
  margin: 0 auto;
  max-width: 1800px;
}

.solution {
  padding: 0;
  border-radius: 30px 30px 0 0;
  margin: 0 10px;
  min-height: 90vh;
  background-color: white;
}

.center {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.all-center {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.pointer {
  cursor: pointer;
}

.public-header {
  padding: 0 10px 18px;
}

.public-logo {
  display: inline-block;
  margin: 0 0 8px 6px;
}
</style>
